<template>
  <div>
    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">
          {{ $t(sidebarTitle) }}
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1">
          <template
            v-if="levelsVisible.includes(reportDomain) && myObj.id == 0"
          >
            <b-col md="12">
              <b-form-group
                :label="$t('Main Classification')"
                :invalid-feedback="$t('Main Classification is required')"
                ref="l1"
              >
                <v-select
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :clearable="false"
                  :options="[
                    { id: 0, title: $t('None') },
                    ...filteredParentOptions,
                  ]"
                  :reduce="(opt) => opt.id"
                  label="title"
                  v-model="levelObj.l1"
                  :placeholder="$t('Select main classification')"
                  @input="setLevel2()"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                :label="$t('Sub Classification')"
                :invalid-feedback="$t('Sub Classification is required')"
                ref="l2"
              >
                <v-select
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :clearable="false"
                  :options="level2Options"
                  :reduce="(opt) => opt.id"
                  label="title"
                  v-model="levelObj.l2"
                  :placeholder="$t('Select sub classification')"
                  :disabled="levelObj.l1 == 0"
                  @input="setLevel3()"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                :label="$t('Group')"
                :invalid-feedback="$t('Group is required')"
                ref="l3"
              >
                <v-select
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :clearable="false"
                  :options="level3Options"
                  :reduce="(opt) => opt.id"
                  label="title"
                  v-model="levelObj.l3"
                  :placeholder="$t('Select group')"
                  :disabled="levelObj.l1 == 0 || levelObj.l2 == 0"
                  @input="generateCode()"
                />
              </b-form-group>
            </b-col>
          </template>

          <b-col md="12" v-else>
            <b-form-group
              :label="$t('Parent Head')"
              :invalid-feedback="$t('Parent head is required')"
            >
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                :options="[{ id: 0, title: $t('None') }, ...parentOptions]"
                :reduce="(opt) => opt.id"
                label="title"
                v-model="myObj.parentHead"
                :placeholder="$t('Select parent')"
                @input="handleParentChange()"
              >
                <!-- <template #option="{ title, code }">
                  <div>{{ title }} - {{ code }}</div>
                </template> -->
              </v-select>
              <!-- @input="setNature()" -->
            </b-form-group>
          </b-col>
          <b-col md="12" v-if="budgetVisible.includes(reportDomain)">
            <b-form-group
              :label="$t('SBU')"
              :invalid-feedback="$t('SBU is required')"
              ref="project"
            >
              <v-select
                multiple
                :closeOnSelect="false"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                v-model="selectedProjects"
                :options="sbuOptionsWithSelectAll"
                label="name"
                :reduce="(opt) => opt.id"
                :clearable="false"
                :placeholder="$t('Select SBU')"
                @input="handleSBUSelection"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Code')"
              :invalid-feedback="$t('Code is required')"
              ref="code"
            >
              <b-input-group v-if="myObj.id > 0">
                <b-form-input
                  :placeholder="$t('Enter code here')"
                  ref="code"
                  v-model="myObj.code"
                />
              </b-input-group>
              <b-input-group v-else>
                <b-form-input
                  :placeholder="$t('Enter code here')"
                  ref="code"
                  v-model="myObj.code"
                />
                <b-input-group-append>
                  <b-button
                    variant="outline-primary"
                    @click="generateCode(true)"
                    :disabled="generatingCode"
                  >
                    <b-spinner v-if="generatingCode" small type="grow" />
                    <span v-else>{{ $t("Generate") }}</span>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Account')"
              :invalid-feedback="$t('Account is required')"
              ref="name"
            >
              <b-form-input
                :placeholder="$t('Enter account name here')"
                ref="name"
                v-model="myObj.title"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Nature')"
              :invalid-feedback="$t('Nature is required')"
              ref="nature"
            >
              <v-select
                ref="nature"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                :options="typeOptions"
                :reduce="(opt) => opt.name"
                label="name"
                v-model="myObj.nature"
                :placeholder="$t('Select nature')"
              />
              <!-- :disabled="myObj.parentHead > 0" -->
            </b-form-group>
          </b-col>
          <b-col
            md="12"
            v-if="myObj.nature == 'Asset' || myObj.nature == 'Liability'"
          >
            <b-form-group
              :label="$t('Type')"
              :invalid-feedback="$t('Type is required')"
              ref="period"
            >
              <v-select
                ref="period"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                :options="periodOptions"
                :reduce="(opt) => opt.text"
                label="text"
                v-model="myObj.period"
                :placeholder="$t('Select type')"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="12"
            v-if="myObj.nature == 'Asset' && myObj.period == 'Non-Current'"
          >
            <b-form-group
              :label="$t('Depreciation %')"
              :invalid-feedback="$t('Depreciation % is required')"
              ref="depr"
            >
              <b-form-input
                ref="depr"
                type="number"
                :placeholder="$t('Enter percentage')"
                v-model="myObj.depreciationPerc"
                @input="checkDep()"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Category')"
              :invalid-feedback="$t('Category is required')"
              ref="cat"
            >
              <v-select
                ref="cat"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                :options="filteredCategoryOptions"
                :reduce="(opt) => opt.value"
                label="text"
                v-model="myObj.cashFlowCategory"
                :placeholder="$t('Select category')"
              />
            </b-form-group>
          </b-col>

          <b-col md="12" v-if="showBelongsToField">
            <b-form-group
              :label="$t('Belongs To')"
              :invalid-feedback="$t('Belongs To is required')"
              ref="belongsTo"
            >
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                :options="effectiveBelongsToOptions"
                :reduce="(opt) => opt.value"
                label="text"
                v-model="myObj.belongsTo"
                :placeholder="$t('Select belongs to')"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              :label="$t('Opening Balance')"
              :invalid-feedback="$t('Opening Balance is required')"
              ref="balance"
            >
              <b-form-input
                type="number"
                step="any"
                min="0"
                :placeholder="$t('Enter opening balance')"
                ref="balance"
                v-model="myObj.openingBalance"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              @click="Add()"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-else> {{ $t(sidebarButton) }} </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      <sidebar-content />
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility2"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Settings") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility2 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1">
          <b-col md="12">
            <b-form-group
              :label="$t('Opening Balance')"
              :invalid-feedback="$t('Opening Balance is required')"
              ref="bal"
            >
              <b-form-input
                :placeholder="$t('Enter balance here')"
                ref="bal"
                v-model="settObj.valueNumber"
              />
            </b-form-group>
          </b-col>

          <b-col md="12" class="mt-1">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              class=""
              @click="saveSetting()"
              :disabled="saving"
              block
            >
              <b-spinner v-if="saving" small type="grow" />
              <span v-else>{{ $t("Save") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      <sidebar-content />
    </b-sidebar>

    <b-modal
      id="modal-budget"
      size="lg"
      :title="modalTitle"
      hide-footer
      centered
      no-close-on-backdrop
    >
      <div>
        <b-button
          v-if="!budgetForm"
          variant="primary"
          @click="addBudget()"
          class="mb-1"
        >
          {{ $t("Add Budget") }}
        </b-button>

        <div v-if="budgetForm">
          <b-form @submit.prevent>
            <b-row>
              <b-col md="6">
                <b-form-group
                  :label="$t('Date')"
                  :invalid-feedback="$t('Date is required')"
                  ref="b_date"
                >
                  <flat-pickr
                    v-model="rangeDate"
                    class="form-control"
                    :config="config"
                    :placeholder="$t('Select date')"
                    @on-change="setDate"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="$t('SBU')"
                  :invalid-feedback="$t('SBU is required')"
                  ref="b_sbu"
                >
                  <v-select
                    v-model="budgetObj.projectID"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="projectList"
                    :clearable="false"
                    :reduce="(val) => val.id"
                    label="name"
                    :placeholder="$t('Select SBU')"
                  ></v-select>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="$t('Amount')"
                  :invalid-feedback="$t('Amount is required')"
                  ref="b_amount"
                >
                  <b-form-input
                    type="number"
                    v-model="budgetObj.budgetAmount"
                    :placeholder="$t('Enter amount')"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <div class="text-right py-1 border-top">
              <b-button
                variant="success"
                class="mr-1"
                :disabled="savingBudget"
                @click="saveBudget()"
              >
                <b-spinner v-if="savingBudget" small type="grow" />
                <span v-else>{{ $t("Save") }}</span>
              </b-button>
              <b-button
                variant="outline-secondary"
                :disabled="savingBudget"
                @click="budgetForm = false"
              >
                {{ $t("Cancel") }}
              </b-button>
            </div>
          </b-form>
        </div>

        <div v-else>
          <b-table
            sticky-header="400px"
            :items="budgetItems"
            :fields="budgetFields"
            responsive
            hover
            :busy="budgetLoading"
            show-empty
            small
          >
            <template #head()="data">
              {{ $t(data.label) }}
            </template>

            <template #table-busy>
              <div class="d-flex justify-content-center my-3">
                <b-spinner
                  style="width: 2rem; height: 2rem"
                  type="grow"
                  variant="primary"
                  :label="$t('Spinning')"
                ></b-spinner>
              </div>
            </template>

            <template #cell(date)="data">
              <b-badge variant="light-primary">
                {{
                  new Date(data.item.dtFrom).toLocaleDateString("en-UK", {
                    year: "numeric",
                    day: "numeric",
                    month: "short",
                  })
                }}
                -
                {{
                  new Date(data.item.dtTo).toLocaleDateString("en-UK", {
                    year: "numeric",
                    day: "numeric",
                    month: "short",
                  })
                }}
              </b-badge>
            </template>
            <template #cell(project)="data">
              <b-badge variant="light-primary">
                {{ getProject(data.item.projectID) }}
              </b-badge>
            </template>
            <template #cell(budgetAmount)="data">
              <b-badge variant="light-primary">
                {{ data.value }}
              </b-badge>
            </template>
            <template #cell(remainingBudget)="data">
              <b-badge variant="light-primary">
                {{ data.value }}
              </b-badge>
            </template>
            <template #cell(actions)="data">
              <!-- <b-button
                variant="primary"
                class="btn-icon mr-50"
                @click="editBudget(data.item)"
              >
                <feather-icon icon="EditIcon" />
              </b-button> -->
              <b-button
                v-if="
                  rights.delete &&
                  data.item.remainingBudget == data.item.budgetAmount
                "
                variant="outline-danger"
                class="btn-icon"
                @click="removeBudget(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>
            </template>
          </b-table>
        </div>
      </div>
    </b-modal>

    <b-card>
      <b-row class="mt-1">
        <b-col xl="2" lg="3" md="4" sm="12" cols="12" v-if="rights.add">
          <b-button
            @click="AddOpen()"
            block
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span class="align-middle">{{ $t("Add Account") }}</span>
          </b-button>
        </b-col>

        <b-col
          class="mt-lg-0 mt-md-0 mt-sm-1 mt-1 d-flex align-items-start flex-wrap"
          xl="10"
          lg="9"
          md="8"
          sm="12"
          cols="12"
        >
          <b-form-group class="mr-2 search-bar-container">
            <b-input-group>
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input
                v-model="searchQuery"
                :placeholder="$t('Search') + '...'"
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>
          <div class="d-flex align-items-center button-group">
            <b-button
              variant="outline-primary"
              class="btn-icon mr-1"
              v-b-tooltip.hover.top
              :title="$t('Print Chart of Accounts')"
              @click="printChartOfAccounts()"
            >
              <feather-icon icon="PrinterIcon" />
            </b-button>
            <b-button
              variant="outline-success"
              class="btn-icon mr-1"
              v-b-tooltip.hover.top
              :title="$t('Expand All')"
              @click="expandAll()"
            >
              <feather-icon icon="ChevronDownIcon" />
            </b-button>
            <b-button
              variant="outline-warning"
              class="btn-icon mr-1"
              v-b-tooltip.hover.top
              :title="$t('Collapse All')"
              @click="collapseAll()"
            >
              <feather-icon icon="ChevronUpIcon" />
            </b-button>
            <b-button
              variant="outline-primary"
              class="btn-icon"
              v-b-tooltip.hover.top
              :title="$t('Set Opening Balance')"
              @click="loadSettings()"
            >
              <feather-icon icon="SettingsIcon" />
            </b-button>
          </div>
        </b-col>
      </b-row>

      <b-table
        class="mt-1"
        ref="selectableTable"
        :items="filters"
        :fields="fields"
        :busy="dataLoading"
        responsive
        show-empty
        hover
        :selectable="rights.edit"
        select-mode="single"
        @row-selected="Edit($event[0])"
      >
        <template #head()="scope">
          <div :class="scope.label == 'actions' && 'text-center'">
            {{ $t(scope.label) }}
          </div>
        </template>

        <template #table-busy>
          <div class="d-flex justify-content-center mb-3 mt-5">
            <b-spinner
              style="width: 3rem; height: 3rem"
              type="grow"
              variant="primary"
              :label="$t('Spinning')"
            ></b-spinner>
          </div>
        </template>
        <template #cell(title)="data">
          <div class="tree-row d-flex align-items-center">
            <!-- Simple clean tree structure -->
            <div
              class="tree-structure"
              :style="{ paddingLeft: data.item.level * 30 + 'px' }"
            >
              <!-- Expand/collapse button -->
              <div class="tree-toggle">
                <span
                  v-if="data.item.children && data.item.children.length > 0"
                  class="tree-expand-btn cursor-pointer"
                  @click.stop="toggleNode(data.item.id)"
                >
                  <feather-icon
                    :icon="
                      data.item.expanded
                        ? 'ChevronDownIcon'
                        : 'ChevronRightIcon'
                    "
                    size="14"
                    class="tree-expand-icon"
                    :class="{ expanded: data.item.expanded }"
                  />
                </span>
                <span v-else class="tree-leaf-spacer"></span>
              </div>

              <!-- Account title - simple and clean -->
              <div class="tree-content">
                <span v-if="!shouldShowPdfLink" class="account-title">
                  {{ data.item.title }}
                </span>
                <a
                  v-else
                  :href="getPdfUrl(data.item.title)"
                  target="_blank"
                  class="account-link"
                  @click.stop
                >
                  <span class="account-title account-title-link">
                    {{ data.item.title }}
                  </span>
                </a>
              </div>
            </div>
          </div>
        </template>
        <template #cell(meta_parentHead)="data">
          <b-badge variant="light-primary">
            {{ data.item.meta_parentHead }}
          </b-badge>
        </template>
        <template #cell(openingBalance)="data">
          <b-badge variant="light-primary">
            {{ data.item.openingBalance }}
          </b-badge>
        </template>
        <template #cell(code)="data">
          <b-badge variant="light-primary">
            {{ data.item.code }}
          </b-badge>
        </template>

        <template #cell(actions)="data">
          <div class="d-flex">
            <b-button
              v-if="budgetVisible.includes(reportDomain) && rights.edit"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              v-b-tooltip.hover.left
              :title="$t('Budget')"
              class="btn-icon mr-1"
              @click="openBudget(data.item)"
            >
              <feather-icon icon="FileTextIcon" class="" />
            </b-button>

            <b-button
              v-if="rights.edit"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              v-b-tooltip.hover.left
              :title="$t('Edit')"
              class="btn-icon mr-1"
              @click="Edit(data.item)"
            >
              <feather-icon icon="EditIcon" class="" />
            </b-button>

            <b-button
              v-if="
                rights.delete &&
                !(data.item.children && data.item.children.length > 0)
              "
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-danger"
              v-b-tooltip.hover.right
              :title="$t('Delete')"
              class="btn-icon"
              @click="Delete(data.item.id)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BBadge,
  BFormGroup,
  BForm,
  BSpinner,
  BSidebar,
  BInputGroupPrepend,
  BInputGroup,
  BInputGroupAppend,
  VBTooltip,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BBadge,
    BFormGroup,
    BForm,
    BSpinner,
    BSidebar,
    BInputGroupPrepend,
    BInputGroup,
    BInputGroupAppend,
    vSelect,
    flatPickr,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  async created() {
    if (!this.$store.state.rights[this.$route.name]) {
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];
      this.loadCoaReceivablePayableSetting();
      this.LoadData();
      if (this.budgetVisible.includes(this.reportDomain)) {
        this.LoadProjects();
      }
    }
  },
  computed: {
    filters: function () {
      if (this.searchQuery) {
        return this.items.filter((pro) => {
          return pro.title.toLowerCase().match(this.searchQuery.toLowerCase());
        });
      }
      return this.getFlattenedTreeItems();
    },
    filteredParentOptions: function () {
      return this.parentOptions.filter((option) => option.parentHead !== 0);
    },
    sbuOptionsWithSelectAll: function () {
      return [{ id: "select-all", name: "Select All" }, ...this.projectList];
    },
    shouldShowPdfLink() {
      return (
        this.reportDomain &&
        this.reportDomain.toLowerCase().includes("myskooliuss")
      );
    },
    /** COA: restricted Bank/Cash category + aligned table/sidebar behavior (myskool, Falcon FGS, ABA, Crestview). */
    usesBankCashCategoryDropdown() {
      return [
        "myskool",
        "myskoolfgs",
        "myskoolaba",
        "myskoolcrestviewacademy",
      ].includes(this.reportDomain);
    },
    coaReceivablePayableEnabled() {
      return this.isTruthySetting(this.coaReceivablePayableSetting);
    },
    showBelongsToField() {
      return (
        this.usesBankCashCategoryDropdown || this.coaReceivablePayableEnabled
      );
    },
    effectiveBelongsToOptions() {
      const options = [
        { text: "Balance Sheet", value: "balance_sheet" },
        { text: "Income Statement", value: "income_statement" },
      ];
      if (this.coaReceivablePayableEnabled) {
        options.push(
          { text: "Accounts Receivable", value: "accounts_receivable" },
          { text: "Accounts Payable", value: "accounts_payable" }
        );
      }
      return options;
    },
    fields() {
      const baseFields = [
        { label: "account", key: "title" },
        { label: "parent", key: "meta_parentHead" },
        { label: "code", key: "code" },
        { key: "actions", label: "actions" },
      ];

      // Hide opening balance column for domains using simplified COA (same as Bank/Cash category restriction)
      if (!this.usesBankCashCategoryDropdown) {
        // Insert opening balance after parent
        baseFields.splice(2, 0, {
          label: "opening balance",
          key: "openingBalance",
        });
      }

      return baseFields;
    },
    filteredCategoryOptions() {
      if (this.usesBankCashCategoryDropdown) {
        return [
          { text: "None", value: "0" },
          { text: "Bank Account", value: "bank_account" },
          { text: "Cash Account", value: "cash_account" },
        ];
      }
      // Otherwise show all options
      return this.categoryOptions;
    },
  },
  watch: {
    "myObj.nature"(newVal) {
      // Automatically set belongsTo to Income Statement when Nature is Expense or Revenue
      if (newVal === "Expense" || newVal === "Revenue") {
        this.myObj.belongsTo = "income_statement";
      } else {
        // Clear belongsTo when Nature is changed to something other than Expense or Revenue
        this.myObj.belongsTo = "";
      }
    },
  },
  data() {
    return {
      rights: {},
      request: false,
      generatingCode: false,
      sidebarTitle: "Add Account",
      sidebarButton: "Save",
      dataLoading: false,
      visibility: false,
      searchQuery: "",
      items: [],
      treeItems: [],
      expandedNodes: new Set(),
      parentOptions: [],
      typeOptions: [
        { name: "Asset", value: "asset" },
        { name: "Equity", value: "equity" },
        { name: "Expense", value: "expense" },
        { name: "Liability", value: "liability" },
        { name: "Revenue", value: "revenue" },
      ],
      categoryOptions: [
        { text: "None", value: "0" },
        { text: "Operations Activities", value: "1" },
        { text: "Investing Activities", value: "2" },
        { text: "Financing Activities", value: "3" },
      ],
      periodOptions: [
        { text: "Current", value: "current" },
        { text: "Non-Current", value: "non-current" },
      ],
      coaReceivablePayableSetting: null,
      myObj: {
        id: 0,
        parent: 0,
        account: "",
        code: 0,
        campusID: this.$store.state.userData.cId,
        belongsTo: "",
      },
      settObj: {
        id: 0,
        key: "opening-balance",
        value: "op",
        valueBool: true,
        valueNumber: 0,
        campusID: this.$store.state.userData.cId,
      },
      visibility2: false,
      saving: false,
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      projectList: [],
      selectedProjects: [],
      rangeDate: null,
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        mode: "range",
      },
      modalTitle: "",
      currentAccount: {},
      budgetItems: [],
      budgetFields: [
        { label: "Date", key: "date" },
        { label: "SBU", key: "project" },
        { label: "Amount", key: "budgetAmount" },
        { label: "Remaining", key: "remainingBudget" },
        { label: "Actions", key: "actions" },
      ],
      budgetLoading: false,
      budgetForm: false,
      savingBudget: false,
      budgetObj: {
        id: 0,
        accountID: 0,
        projectID: 0,
        dtFrom: null,
        dtTo: null,
        budgetAmount: 0,
        remainingBudget: 0,
        campusID: this.$store.state.userData.cId,
      },
      budgetVisible: ["myskoolhpgs"],
      levelsVisible: ["myskoolhpgs"],
      levelObj: {
        l1: 0,
        l2: 0,
        l3: 0,
      },
      level2Options: [],
      level3Options: [],
    };
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    isTruthySetting(setting) {
      if (!setting) return false;
      if (setting.valueBool === true || setting.valueBool === 1) return true;
      if (typeof setting.valueBool === "string") {
        const t = setting.valueBool.toLowerCase().trim();
        return t === "true" || t === "1";
      }
      return false;
    },

    async loadCoaReceivablePayableSetting() {
      try {
        const res = await this.post({
          url:
            this.$store.state.domain +
            "Settings/getSettingsAll?db=" +
            this.$store.state.userData.db,
          body: ["coa_receivable_payable"],
          context: this,
          token: this.$store.state.userData.token,
          subjects: true,
        });
        this.coaReceivablePayableSetting =
          (Array.isArray(res) &&
            res.find((el) => el.key === "coa_receivable_payable")) ||
          null;
      } catch (e) {
        this.coaReceivablePayableSetting = null;
      }
    },

    getPdfUrl(title) {
      const cID = this.$store.state.userData.cId;
      const encodedTitle = encodeURIComponent(title);
      return `https://cdn.cloudious.net/IUSS/${cID}/${encodedTitle}.pdf`;
    },

    buildTreeStructure(
      items,
      idField = "id",
      parentField = "parentHead",
      levelField = "level"
    ) {
      console.log("Building tree structure for items:", items);

      const itemMap = new Map();
      const rootNodes = [];

      // Create nodes first
      items.forEach((item) => {
        itemMap.set(item[idField], {
          ...item,
          children: [],
          expanded: true,
          originalData: item,
          level: 0,
        });
      });

      // Build relationships and calculate levels
      items.forEach((item) => {
        const node = itemMap.get(item[idField]);
        const parentId = item[parentField];

        // Handle self-referencing parent (main categories like Revenue, Expense, etc.)
        if (parentId === item[idField]) {
          // This is a main category (Revenue, Expense, Assets, etc.)
          rootNodes.push(node);
          node.level = 0;
          console.log(
            `Added main category: ${item.title} (level ${node.level})`
          );
        } else if (parentId && parentId !== 0 && itemMap.has(parentId)) {
          // This is a child of another category
          const parentNode = itemMap.get(parentId);
          parentNode.children.push(node);
          node.level = parentNode.level + 1;
          console.log(
            `Added ${item.title} (level ${node.level}) as child of ${parentNode.title}`
          );
        } else if (parentId === 0) {
          // This is a root level item (no parent)
          rootNodes.push(node);
          node.level = 0;
          console.log(`Added root item: ${item.title} (level ${node.level})`);
        } else {
          // Parent not found, treat as root
          rootNodes.push(node);
          node.level = 0;
          console.log(
            `Added orphaned item as root: ${item.title} (level ${node.level})`
          );
        }
      });

      // Sort children within each node
      const isMySkool = this.usesBankCashCategoryDropdown;

      // Helper function to compare codes for sorting (handles both numeric and alphanumeric codes)
      const compareCodes = (codeA, codeB) => {
        const a = (codeA || "").toString().trim();
        const b = (codeB || "").toString().trim();

        // Try numeric comparison first
        const numA = parseFloat(a);
        const numB = parseFloat(b);

        if (!isNaN(numA) && !isNaN(numB)) {
          return numA - numB;
        }

        // If not numeric, do alphanumeric comparison
        // Split by numbers and text parts for proper sorting
        const partsA = a.match(/(\d+|\D+)/g) || [];
        const partsB = b.match(/(\d+|\D+)/g) || [];

        const maxLength = Math.max(partsA.length, partsB.length);
        for (let i = 0; i < maxLength; i++) {
          const partA = partsA[i] || "";
          const partB = partsB[i] || "";

          const numPartA = parseFloat(partA);
          const numPartB = parseFloat(partB);

          if (!isNaN(numPartA) && !isNaN(numPartB)) {
            if (numPartA !== numPartB) {
              return numPartA - numPartB;
            }
          } else {
            const comparison = partA.localeCompare(partB);
            if (comparison !== 0) {
              return comparison;
            }
          }
        }

        return 0;
      };

      const sortChildren = (nodes) => {
        // Sort the nodes themselves first
        if (isMySkool) {
          // Sort by code for myskool domain
          nodes.sort((a, b) => {
            const codeA = a.originalData?.code || a.code || "";
            const codeB = b.originalData?.code || b.code || "";
            return compareCodes(codeA, codeB);
          });
        } else {
          // Sort by title for other domains
          nodes.sort((a, b) => {
            const titleA = a.title || "";
            const titleB = b.title || "";
            return titleA.localeCompare(titleB);
          });
        }

        // Then sort children recursively
        nodes.forEach((node) => {
          if (node.children && node.children.length > 0) {
            sortChildren(node.children);
          }
        });
      };

      sortChildren(rootNodes);

      console.log("Final tree structure:", rootNodes);
      return rootNodes;
    },

    getFlattenedTreeItems() {
      const flattened = [];

      const flattenNode = (node) => {
        flattened.push(node);
        console.log(
          `Flattening node: ${node.title} (level ${node.level}, expanded: ${
            node.expanded
          }, children: ${node.children ? node.children.length : 0})`
        );
        if (node.expanded && node.children && node.children.length > 0) {
          node.children.forEach((child) => flattenNode(child));
        }
      };

      console.log("Starting to flatten tree items:", this.treeItems);
      this.treeItems.forEach((rootNode) => flattenNode(rootNode));
      console.log("Final flattened items:", flattened);
      return flattened;
    },

    toggleNode(nodeId) {
      if (this.expandedNodes.has(nodeId)) {
        this.expandedNodes.delete(nodeId);
      } else {
        this.expandedNodes.add(nodeId);
      }

      // Update the tree structure
      const updateNodeExpansion = (nodes) => {
        nodes.forEach((node) => {
          node.expanded = this.expandedNodes.has(node.id);
          if (node.children && node.children.length > 0) {
            updateNodeExpansion(node.children);
          }
        });
      };

      updateNodeExpansion(this.treeItems);
    },

    expandAll() {
      const expandAllNodes = (nodes) => {
        nodes.forEach((node) => {
          this.expandedNodes.add(node.id);
          node.expanded = true;
          if (node.children && node.children.length > 0) {
            expandAllNodes(node.children);
          }
        });
      };

      expandAllNodes(this.treeItems);
    },

    collapseAll() {
      this.expandedNodes.clear();
      const collapseAllNodes = (nodes) => {
        nodes.forEach((node) => {
          node.expanded = false;
          if (node.children && node.children.length > 0) {
            collapseAllNodes(node.children);
          }
        });
      };

      collapseAllNodes(this.treeItems);
    },

    setLevel2() {
      this.levelObj.l2 = 0;
      this.levelObj.l3 = 0;
      this.level2Options = [];
      this.level3Options = [];

      if (this.levelObj.l1 > 0) {
        this.level2Options = this.items.filter(
          (el) => el.parentHead == this.levelObj.l1
        );
      }
      this.generateCode();
    },
    setLevel3() {
      this.levelObj.l3 = 0;

      this.level3Options = this.items.filter(
        (el) => el.parentHead == this.levelObj.l2
      );
      this.generateCode();
    },

    handleParentChange() {
      this.setNature();
      this.generateCode();
    },

    handleSBUSelection(selectedValues) {
      // Check if "Select All" was selected
      if (selectedValues.includes("select-all")) {
        // If "Select All" is selected, select all project IDs
        this.selectedProjects = this.projectList.map((project) => project.id);
      } else {
        // Otherwise, use the selected values as is
        this.selectedProjects = selectedValues;
      }
    },

    async generateCode(manuallyTriggered = false) {
      // Determine parentID based on the hierarchy
      let parentID = 0;

      if (
        this.levelsVisible.includes(this.reportDomain) &&
        this.myObj.id == 0
      ) {
        // Priority: Group > Sub Classification > Main Classification
        if (this.levelObj.l3 > 0) {
          parentID = this.levelObj.l3; // Group ID
        } else if (this.levelObj.l2 > 0) {
          parentID = this.levelObj.l2; // Sub Classification ID
        } else if (this.levelObj.l1 > 0) {
          parentID = this.levelObj.l1; // Main Classification ID
        }
      } else {
        // For edit mode or when levels are not visible, use parentHead
        parentID = this.myObj.parentHead || 0;
      }

      // Validate that a parent is selected
      if (parentID === 0) {
        if (manuallyTriggered) {
          this.$bvToast.toast(
            this.$t(
              "Please select a parent account first before generating code"
            ),
            {
              title: this.$t("Parent Required"),
              variant: "warning",
              toaster: "b-toaster-top-center",
              autoHideDelay: 4000,
            }
          );
        }
        return;
      }

      this.generatingCode = true;

      try {
        const obj = {
          url: `${this.$store.state.domain}Accounts/GenerateCode?db=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}&parentID=${parentID}`,
          token: this.$store.state.userData.token,
        };

        const res = await this.get(obj);
        let finalCode = "";

        // Handle both JSON response and direct string response
        if (res && res.status === "success" && res.data !== undefined) {
          finalCode = res.data;
        } else if (res && typeof res === "string") {
          finalCode = res;
        } else if (res) {
          // Fallback for cases where it might return just the code as an object or something else
          finalCode = res.toString();
        }

        if (finalCode) {
          // Clean the generated code by removing any brackets or unwanted characters
          let cleanCode = finalCode
            .toString()
            .replace(/[\[\]]/g, "")
            .trim();
          
          this.$set(this.myObj, "code", cleanCode);

          this.$bvToast.toast(this.$t("Code generated successfully"), {
            title: this.$t("Success"),
            variant: "success",
            toaster: "b-toaster-top-center",
          });
        }
      } catch (error) {
        console.error("Error generating code:", error);

        // Extract error message from response
        let errorMessage = this.$t("Failed to generate code. Please try again");
        if (error && error.response && error.response.data) {
          const errorData = error.response.data;
          if (
            typeof errorData === "string" &&
            errorData.includes("Parent account not found")
          ) {
            errorMessage = this.$t(
              "Parent account not found. Please select a valid parent account"
            );
          } else if (errorData.message) {
            errorMessage = errorData.message;
          } else if (typeof errorData === "string") {
            errorMessage = errorData;
          }
        } else if (error && error.message) {
          if (error.message.includes("Parent account not found")) {
            errorMessage = this.$t(
              "Parent account not found. Please select a valid parent account"
            );
          } else {
            errorMessage = error.message;
          }
        }

        this.$bvToast.toast(errorMessage, {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
          autoHideDelay: 5000,
        });
      } finally {
        this.generatingCode = false;
      }
    },

    getProject(id) {
      let obj = this.projectList.find((el) => el.id == id);
      return obj ? obj.name : "";
    },

    async openBudget(item) {
      // Use originalData if it's a tree node, otherwise use the item directly
      const budgetItem = item.originalData || item;
      this.currentAccount = { ...budgetItem };
      this.modalTitle = this.$t("Manage Budget") + " - " + budgetItem.title;
      this.$bvModal.show("modal-budget");

      this.budgetForm = false;

      this.budgetLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "AccountsBudget/LoadSelected?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          budgetItem.campusID +
          "&accountID=" +
          budgetItem.id,
        token: this.$store.state.userData.token,
      };
      this.budgetItems = await this.get(obj);
      // console.log(this.budgetItems);
      this.budgetLoading = false;
    },
    addBudget() {
      this.budgetObj = {
        id: 0,
        accountID: this.currentAccount.id,
        projectID: 0,
        dtFrom: null,
        dtTo: null,
        budgetAmount: 0,
        remainingBudget: 0,
        campusID: this.currentAccount.campusID,
      };
      this.budgetForm = true;
      this.rangeDate = null;
    },
    editBudget(item) {
      this.budgetObj = { ...item };
      this.budgetForm = true;
      this.rangeDate = `${item.dtFrom} to ${item.dtTo}`;
    },
    setDate(sd, dateStr) {
      // console.log(sd, dateStr);
      if (dateStr) {
        if (sd.length > 1) {
          let date = dateStr.split(" to ");
          if (date.length == 1) {
            this.budgetObj.dtFrom = date[0];
            this.budgetObj.dtTo = date[0];
          } else {
            this.budgetObj.dtFrom = date[0];
            this.budgetObj.dtTo = date[1];
          }
        } else {
          this.budgetObj.dtFrom = dateStr;
          this.budgetObj.dtTo = null;
        }
      } else {
        this.budgetObj.dtFrom = null;
        this.budgetObj.dtTo = null;
      }
      // console.log(this.budgetObj);
    },
    CheckDate() {
      var elem = this.$refs["b_date"];
      // console.log(this.budgetObj.dtFrom, this.budgetObj.dtTo);
      if (!this.budgetObj.dtFrom || !this.budgetObj.dtTo) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckSBU() {
      var elem = this.$refs["b_sbu"];
      if (this.budgetObj.projectID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckBAmount() {
      var elem = this.$refs["b_amount"];
      let x = parseInt(this.budgetObj.budgetAmount);
      if (isNaN(x) || x <= 0) {
        return (elem.state = false);
      } else {
        this.budgetObj.budgetAmount = x;
        return (elem.state = true);
      }
    },
    async saveBudget() {
      const s1 = this.CheckDate();
      const s2 = this.CheckSBU();
      const s3 = this.CheckBAmount();

      if (s1 && s2 && s3) {
        this.savingBudget = true;
        this.budgetObj.remainingBudget = this.budgetObj.budgetAmount;
        // console.log(this.budgetObj);

        let status = false;
        if (this.budgetObj.id == 0) {
          status = await this.post({
            url:
              this.$store.state.domain +
              "AccountsBudget?db=" +
              this.$store.state.userData.db,
            body: this.budgetObj,
            message: this.$t("Budget added successfully"),
            context: this,
            token: this.$store.state.userData.token,
          });
        } else {
          status = await this.put({
            url:
              this.$store.state.domain +
              "AccountsBudget/" +
              this.budgetObj.id +
              "?db=" +
              this.$store.state.userData.db,
            message: this.$t("Budget updated successfully"),
            context: this,
            body: this.budgetObj,
            token: this.$store.state.userData.token,
          });
        }
        this.savingBudget = false;

        if (status) {
          this.budgetForm = false;
          await this.openBudget(this.currentAccount);
        }
      } else {
        this.$bvToast.toast(this.$t("Please enter the details correctly"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
    },
    async removeBudget(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });
      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "AccountsBudget/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          message: this.$t("Budget removed successfully"),
          context: this,
          token: this.$store.state.userData.token,
          showError: true,
        });
        if (status) this.openBudget(this.currentAccount);
      }
    },

    setNature() {
      if (this.myObj.parentHead > 0) {
        this.myObj.nature = this.parentOptions.find(
          (el) => el.id == this.myObj.parentHead
        ).nature;
        // console.log(this.myObj.nature);
      }
    },

    async loadSettings() {
      var obj = {
        url:
          this.$store.state.domain +
          "Settings/LoadSettings?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: ["op"],
        context: this,
        subjects: true,
        token: this.$store.state.userData.token,
      };
      let res = await this.post(obj);
      this.settObj = res[0];
      // console.log(this.settObj);

      this.visibility2 = true;
      var elem = this.$refs["bal"];
      elem.state = undefined;
    },

    checkVal() {
      var elem = this.$refs["bal"];
      if (isNaN(parseInt(this.settObj.valueNumber))) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async saveSetting() {
      if (this.checkVal() == true) {
        this.settObj.valueNumber = parseInt(this.settObj.valueNumber);
        this.saving = true;
        // console.log(this.settObj);
        var status = await this.put({
          url:
            this.$store.state.domain +
            "Settings/SaveSettings?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: [this.settObj],
          message: this.$t("Settings saved successfully"),
          context: this,
          token: this.$store.state.userData.token,
          showError: true,
        });
        this.saving = false;
        if (status) {
          this.visibility2 = false;
        }
      }
    },

    async Edit(item) {
      // Use originalData if it's a tree node, otherwise use the item directly
      const editItem = item.originalData || item;
      this.myObj = { ...editItem };
      this.selectedProjects = [];
      if (this.budgetVisible.includes(this.reportDomain)) {
        this.LoadAccProjects(editItem);
      }
      // this.setNature();
      if (this.myObj.period == "current") this.myObj.period = "Current";
      else if (this.myObj.period == "non-current")
        this.myObj.period = "Non-Current";
      this.visibility = true;
      this.sidebarTitle = "Edit account";
      this.sidebarButton = "Update";
      var elem = this.$refs["name"];
      elem.state = undefined;
      var elem = this.$refs["code"];
      elem.state = undefined;
      // var elem = this.$refs["parent"];
      // elem.state = undefined;
      var elem = this.$refs["nature"];
      elem.state = undefined;
    },
    async LoadAccProjects(item) {
      var obj = {
        url:
          this.$store.state.domain +
          "Accounts/LoadDataSelected?db=" +
          this.$store.state.userData.db +
          "&accountID=" +
          item.id,
        token: this.$store.state.userData.token,
        dashboard: true,
      };
      const res = await this.get(obj);
      // console.log(res);
      if (res.projectID && res.projectID.length > 0) {
        this.selectedProjects = res.projectID;
      } else this.selectedProjects = [];
    },

    AddOpen() {
      this.myObj = {
        id: 0,
        title: "",
        code: "",
        parentHead: 0,
        nature: "",
        openingBalance: 0,
        cashFlowCategory: "0",
        period: "Current",
        depreciationPerc: 0,
        campusID: this.$store.state.userData.cId,
        belongsTo: "",
      };
      this.selectedProjects = [];
      this.visibility = true;
      this.sidebarTitle = "Add account";
      this.sidebarButton = "Save";
      var elem = this.$refs["name"];
      elem.state = undefined;
      var elem = this.$refs["code"];
      elem.state = undefined;
      // var elem = this.$refs["parent"];
      // elem.state = undefined;
      var elem = this.$refs["nature"];
      elem.state = undefined;

      if (this.levelsVisible.includes(this.reportDomain)) {
        this.levelObj = {
          l1: 0,
          l2: 0,
          l3: 0,
        };
        this.level2Options = [];
        this.level3Options = [];
      }
    },

    CheckName() {
      var elem = this.$refs["name"];
      if (this.myObj.title == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckCode() {
      var elem = this.$refs["code"];
      if (this.myObj.code === "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckParent() {
      var elem = this.$refs["parent"];
      if (this.myObj.parentHead == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckType() {
      var elem = this.$refs["nature"];
      if (this.myObj.nature == "" || this.myObj.nature == null) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckPeriod() {
      if (this.myObj.nature == "Asset" || this.myObj.nature == "Liability") {
        var elem = this.$refs["period"];
        if (!this.myObj.period) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    checkDep() {
      if (this.myObj.nature == "Asset" && this.myObj.period == "Non-Current") {
        var elem = this.$refs["depr"];
        let x = parseFloat(this.myObj.depreciationPerc);
        if (isNaN(x) || x < 0 || x > 100) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },

    async LoadProjects() {
      var obj = {
        url:
          this.$store.state.domain +
          "AccountsDepartment?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.projectList = await this.get(obj);
    },

    async LoadData() {
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "Accounts/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      const response = await this.get(obj);

      // Handle the new API response structure
      if (response && response.status === "success" && response.data) {
        this.items = response.data;
      } else if (Array.isArray(response)) {
        // Fallback for old API format
        this.items = response;
      } else {
        this.items = [];
      }

      console.log("Chart of Accounts API Response:", response);
      console.log("Processed Items:", this.items);

      // Build tree structure
      this.treeItems = this.buildTreeStructure(this.items);

      // Initialize expanded nodes (expand all by default)
      this.expandAll();

      console.log("Raw Items:", this.items);
      console.log("Tree Items:", this.treeItems);
      console.log("Flattened Items:", this.getFlattenedTreeItems());

      // Debug: Check if items have the right structure
      if (this.items && this.items.length > 0) {
        console.log("Sample item structure:", this.items[0]);
        console.log(
          "Items with parentHead 0 (root items):",
          this.items.filter((item) => item.parentHead === 0)
        );
        console.log(
          "Items with parentHead 1 (Revenue children):",
          this.items.filter((item) => item.parentHead === 1)
        );
        console.log(
          "Items with parentHead 2 (Expense children):",
          this.items.filter((item) => item.parentHead === 2)
        );
      }

      var obj2 = {
        url:
          this.$store.state.domain +
          "Accounts/LoadParents?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.parentOptions = await this.get(obj2);
      // console.log("par", this.parentOptions);

      this.dataLoading = false;
    },

    async Add() {
      this.CheckName();
      this.CheckCode();
      this.CheckType();
      this.CheckPeriod();
      this.checkDep();
      // this.CheckParent();
      if (
        this.CheckName() == true &&
        this.CheckCode() == true &&
        this.CheckType() == true &&
        this.CheckPeriod() == true &&
        this.checkDep() == true
        // this.CheckParent() == true
      ) {
        this.request = true;

        if (
          this.levelsVisible.includes(this.reportDomain) &&
          this.myObj.id == 0
        ) {
          let parentID = 0;
          if (this.levelObj.l3 > 0) parentID = this.levelObj.l3;
          else if (this.levelObj.l2 > 0) parentID = this.levelObj.l2;
          else if (this.levelObj.l1 > 0) parentID = this.levelObj.l1;
          this.myObj.parentHead = parentID;
        }
        this.myObj.openingBalance = this.normalizeOpeningBalance(
          this.myObj.openingBalance
        );
        this.myObj.depreciationPerc = parseFloat(this.myObj.depreciationPerc);
        // console.log("obj:", this.myObj);
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Accounts/save?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&projectIDs=" +
            this.selectedProjects +
            "&userID=" +
            this.$store.state.userData.userID,
          body: this.myObj,
          message: this.$t("Account added successfully"),
          context: this,
          token: this.$store.state.userData.token,
          showError: true,
        });
        this.request = false;
        if (status) {
          this.LoadData();
          this.visibility = false;
        }
      }
    },

    async Delete(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });
      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "Accounts/Delete?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&id=" +
            id +
            "&userID=" +
            this.$store.state.userData.userID,
          message: this.$t("account removed successfully"),
          context: this,
          token: this.$store.state.userData.token,
          showError: true,
        });
        if (status) {
          this.LoadData();
        }
      }
    },

    printChartOfAccounts() {
      console.log("Generating Chart of Accounts print report...");

      // Create the HTML content for the print view
      const printContent = this.generatePrintableHTML();

      // Open in new tab
      try {
        const reportWindow = window.open("", "_blank");

        if (reportWindow) {
          reportWindow.document.open("text/html", "replace");
          reportWindow.document.write(printContent);
          reportWindow.document.close();
          reportWindow.document.title = "Chart of Accounts";
          // Focus the new window
          setTimeout(() => {
            reportWindow.focus();
          }, 100);
        } else {
          this.$bvToast.toast(
            this.$t("Pop-up blocked! Please allow pop-ups for this site"),
            {
              title: this.$t("Error"),
              variant: "warning",
            }
          );
        }
      } catch (error) {
        console.error("Error opening report window:", error);
        this.$bvToast.toast(
          this.$t("Failed to open report window") + ": " + error.message,
          {
            title: this.$t("Error"),
            variant: "danger",
          }
        );
      }
    },

    generatePrintableHTML() {
      // Get campus name
      const campusName =
        this.$store.state.currentBranch?.branch ||
        this.$store.state.currentBranch?.name ||
        "";
      const isMySkool = this.usesBankCashCategoryDropdown;
      const treeData = this.treeItems || [];

      // Generate tree structure HTML with proper indentation and tree connectors
      const generateTreeHTML = (nodes, level = 0, parentPath = []) => {
        let html = "";

        nodes.forEach((node, index) => {
          const isLastNode = index === nodes.length - 1;
          const isParent = node.children && node.children.length > 0;
          const parentCode = this.getParentCode(node.id);
          const originalData = node.originalData || node;

          // Calculate indent based on level
          const indent = level * 20; // 20px per level

          // Build simple tree connector - clean and proper
          let treeConnector = "";
          if (level > 0) {
            // Add vertical lines for parent levels
            for (let i = 0; i < level - 1; i++) {
              if (parentPath[i] !== false) {
                treeConnector +=
                  '<span style="color: #d1d5db; font-family: monospace; font-size: 12px; margin-right: 0; display: inline-block; width: 18px; text-align: center;">│</span>';
              } else {
                treeConnector +=
                  '<span style="color: transparent; font-family: monospace; font-size: 12px; margin-right: 0; display: inline-block; width: 18px; text-align: center;">│</span>';
              }
            }

            // Add connector for current level - simple and clean
            if (isLastNode) {
              treeConnector +=
                '<span style="color: #9ca3af; font-family: monospace; font-size: 12px; margin-right: 6px;">└─</span>';
            } else {
              treeConnector +=
                '<span style="color: #9ca3af; font-family: monospace; font-size: 12px; margin-right: 6px;">├─</span>';
            }
          }

          // Simple tree structure - clean and proper
          let rowClass = "";
          let bgColor = "#ffffff";
          let borderColor = "#e5e7eb";
          let textColor = "#1f2937";
          let fontWeight = "normal";
          let fontSize = "12px";

          if (level === 0) {
            // Root level - slightly different background
            rowClass = "root-level";
            bgColor = "#f8f9fa"; // Light gray
            borderColor = "#dee2e6";
            textColor = "#212529";
            fontWeight = "bold";
            fontSize = "13px";
          } else {
            // All child levels - simple white background
            rowClass = "level-" + level;
            bgColor = "#ffffff";
            borderColor = "#e9ecef";
            textColor = "#495057";
            fontWeight = "normal";
            fontSize = "12px";
          }

          // Build table row HTML conditionally based on reportDomain
          let openingBalanceCell = "";
          if (!isMySkool) {
            openingBalanceCell = `
              <td style="padding: 6px 8px; border: 1px solid #ccc; text-align: right; font-weight: ${
                level === 0 ? "bold" : "normal"
              }; font-size: ${fontSize}; color: ${textColor};">
                ${this.formatNumber(originalData.openingBalance || 0)}
              </td>
            `;
          }

          let rowHTML = `
            <tr class="${rowClass}" style="background-color: ${bgColor};">
              <td style="padding-left: ${
                indent + 10
              }px; padding: 6px 8px; border: 1px solid #ccc; font-size: ${fontSize}; font-weight: ${fontWeight}; color: ${textColor};">
                ${treeConnector}
                ${node.title || "N/A"}
              </td>
              <td style="padding: 6px 8px; border: 1px solid #ccc; text-align: center; font-weight: ${
                level === 0 ? "bold" : "normal"
              }; font-size: ${fontSize}; color: ${textColor};">
                ${originalData.code || "N/A"}
              </td>
              <td style="padding: 6px 8px; border: 1px solid #ccc; text-align: center; font-size: ${fontSize}; color: ${textColor};">
                ${parentCode || "-"}
              </td>
              ${openingBalanceCell}
              <td style="padding: 6px 8px; border: 1px solid #ccc; text-align: center; font-size: ${fontSize}; color: ${textColor};">
                ${originalData.nature || "N/A"}
              </td>
            </tr>
          `;

          html += rowHTML;

          // Build new path for children - track which parents need vertical lines
          const newParentPath = [...parentPath];
          if (level > 0) {
            newParentPath[level - 1] = !isLastNode; // true if not last, false if last
          }

          // Recursively add children
          if (node.children && node.children.length > 0) {
            html += generateTreeHTML(node.children, level + 1, newParentPath);
          }
        });

        return html;
      };

      const tableRows = generateTreeHTML(treeData, 0, []);
      const reportTitle = "Chart of Accounts";

      // Generate table headers conditionally
      let tableHeaders = `
        <th style="text-align:left">Account Name</th>
        <th style="text-align:center">Code</th>
        <th style="text-align:center">Parent</th>
      `;
      if (!isMySkool) {
        tableHeaders += `<th style="text-align:right">Opening Balance</th>`;
      }
      tableHeaders += `<th style="text-align:center">Nature</th>`;

      return `
        <!DOCTYPE html>
        <html lang="en">
        <head>
          <meta charset="UTF-8">
          <meta http-equiv="X-UA-Compatible" content="IE=edge">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>${reportTitle}</title>
          <link rel="icon" href="data:,">
          <style>
            *{margin:0;padding:0;box-sizing:border-box}
            html,body{font-family:Arial,sans-serif;font-size:13px;color:#000;background:#fff;margin:0;padding:0;min-height:100vh;visibility:visible}
            body{padding:10px 12px;line-height:1.4;display:block}
            .header{text-align:left;margin-bottom:8px;padding-bottom:5px;border-bottom:1px solid #000}
            .header h1{font-size:20px;font-weight:700;margin:0 0 3px 0}
            .header .campus{font-size:13px;margin:2px 0}
            .table-wrapper{width:100%;overflow:visible}
            table{width:100%;border-collapse:collapse;font-size:12px}
            th{background:#e5e7eb;border:1px solid #000;padding:8px 10px;text-align:left;font-weight:700;font-size:12px}
            th:nth-child(2),th:nth-child(3){text-align:center}
            ${
              !isMySkool
                ? `
            th:nth-child(4){text-align:right}
            th:nth-child(5){text-align:center}
            `
                : `
            th:nth-child(4){text-align:center}
            `
            }
            td{border:1px solid #ccc;padding:6px 8px;font-size:12px;word-wrap:break-word}
            .print-btn{position:fixed;top:10px;right:10px;background:#7c5dfa;color:#fff;border:none;padding:8px 16px;border-radius:4px;cursor:pointer;font-size:12px;z-index:1000}
            @media print{
              @page{margin:5mm;size:A4 portrait;marks:none}
              html,body{margin:0;padding:0}
              body{padding:8px 10px;font-size:12px;line-height:1.3}
              .header{margin:0 0 6px 0;padding:0 0 4px 0;page-break-after:avoid}
              .header h1{font-size:18px;margin:0 0 3px 0}
              .header .campus{font-size:12px;margin:2px 0}
              th{background:#e5e7eb;border:1px solid #000;padding:7px 8px;font-size:12px;font-weight:700}
              td{border:1px solid #ccc;padding:6px 8px;font-size:12px}
              .print-btn{display:none}
              table{page-break-inside:auto;margin:0;width:100%;border-collapse:collapse}
              tr{page-break-inside:avoid;page-break-after:auto}
              thead{display:table-header-group}
              tfoot{display:table-footer-group}
              body>*:first-child{margin-top:0}
              body>*:last-child{margin-bottom:0}
            }
          </style>
        </head>
        <body>
          <button class="print-btn" onclick="window.print()">Print</button>
          <div class="header">
            <h1>${reportTitle}</h1>
            ${campusName ? `<div class="campus">${campusName}</div>` : ""}
          </div>
          <table>
            <thead>
              <tr>
                ${tableHeaders}
              </tr>
            </thead>
            <tbody>
              ${tableRows}
            </tbody>
          </table>
        </body>
        </html>
      `;
    },

    getParentCode(accountId) {
      if (!accountId || accountId === 0) return "-";

      // Find the account in items
      const account = this.items.find((item) => item.id === accountId);
      if (!account || !account.parentHead || account.parentHead === 0) {
        return "-";
      }

      // Find parent account
      const parent = this.items.find((item) => item.id === account.parentHead);
      return parent ? parent.code || "-" : "-";
    },

    normalizeOpeningBalance(value) {
      if (value === "" || value === null || value === undefined) return 0;
      const n = parseFloat(String(value).replace(/,/g, ""));
      if (!Number.isFinite(n)) return 0;
      return Math.round(n * 100) / 100;
    },

    formatNumber(num) {
      if (!num && num !== 0) return "0.00";
      const number = parseFloat(num);
      if (isNaN(number)) return "0.00";
      return number.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style scoped>
/* Modern Card Styling */
::v-deep .card {
  background: linear-gradient(180deg, #ffffff 0%, #faf9ff 100%);
  border: 1px solid #e0d8ff;
  border-radius: 20px;
  padding: 1.5rem 1.75rem 1.5rem 1.5rem;
  box-shadow: 0 10px 30px rgba(115, 103, 240, 0.12);
  margin-bottom: 1.5rem;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  position: relative;
  overflow: visible;
}

::v-deep .card:hover {
  box-shadow: 0 15px 40px rgba(115, 103, 240, 0.2);
  transform: translateY(-2px);
}

.cursor-pointer {
  cursor: pointer;
}

/* Search Bar and Button Group Styling */
.search-bar-container {
  flex: 1;
  min-width: 200px;
  max-width: 100%;
  margin-right: 1rem;
}

.search-bar-container .input-group {
  width: 100%;
}

.search-bar-container .form-control {
  height: 38px;
  border-radius: 8px;
  border: 1px solid #e0d8ff;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  transition: all 0.2s ease;
}

.search-bar-container .form-control:focus {
  border-color: #7c5dfa;
  box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.1);
}

.search-bar-container .input-group-prepend {
  border-radius: 8px 0 0 8px;
  border: 1px solid #e0d8ff;
  border-right: none;
  background: #f8f7ff;
}

.button-group {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.button-group .btn-icon {
  min-width: 38px;
  height: 38px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 1px solid #e0d8ff;
  transition: all 0.2s ease;
}

.button-group .btn-icon:hover {
  background: #f8f7ff;
  border-color: #7c5dfa;
  transform: scale(1.05);
}

/* Tree Structure Styling - Modern and Clean */
.tree-row {
  min-height: 40px;
  transition: all 0.2s ease;
}

.tree-row:hover {
  background-color: transparent;
}

.tree-structure {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  padding-left: 0;
}

.tree-toggle {
  position: relative;
  z-index: 2;
  margin-right: 12px;
  flex-shrink: 0;
}

.tree-expand-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 6px;
  background-color: #f8f9fa;
  border: 1px solid #e0d8ff;
  transition: all 0.2s ease;
  cursor: pointer;
}

.tree-expand-btn:hover {
  background-color: #f0edff;
  border-color: #7c5dfa;
  transform: scale(1.05);
}

.tree-expand-icon {
  transition: transform 0.2s ease;
  color: #6b7280;
}

.tree-expand-icon.expanded {
  color: #7c5dfa;
}

.tree-leaf-spacer {
  display: inline-block;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.tree-content {
  flex: 1;
  min-width: 0;
}

.account-title {
  font-size: 0.9rem;
  font-weight: 500;
  color: #475569;
  display: inline-block;
  padding: 6px 10px;
  border-radius: 8px;
  transition: all 0.2s ease;
  line-height: 1.5;
}

.account-title:hover {
  background-color: #f8fafc;
  color: #2d1b69;
}

.account-link {
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease;
  color: inherit;
}

.account-link:hover {
  background-color: transparent;
}

.account-link:hover .account-title-link {
  background-color: #f0edff;
  color: #7c5dfa;
  font-weight: 600;
}

.account-title-link {
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 8px;
  display: inline-block;
  transition: all 0.2s ease;
  color: #475569;
}

/* Enhanced table styling - Modern Design */
::v-deep .table {
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

::v-deep .table thead th {
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border: none;
  font-weight: 700;
  color: #1e293b;
  text-transform: uppercase;
  font-size: 0.7rem;
  letter-spacing: 0.5px;
  padding: 0.75rem 0.875rem;
  border-bottom: 1px solid #e2e8f0;
}

::v-deep .table tbody td {
  padding: 0.875rem 0.875rem;
  border-bottom: 1px solid #f1f5f9;
  font-size: 0.8125rem;
  color: #475569;
  vertical-align: middle;
}

::v-deep .table tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
}

::v-deep .table tbody tr:hover {
  background: linear-gradient(90deg, #f8fafc 0%, #ffffff 100%);
  border-left-color: #7c5dfa;
  box-shadow: 0 2px 8px rgba(124, 93, 250, 0.08);
  transform: translateX(2px);
}

::v-deep .table tbody tr:last-child td {
  border-bottom: none;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .search-bar-container {
    flex: 1 1 100%;
    margin-right: 0;
    margin-bottom: 0.5rem;
    min-width: 100%;
  }

  .button-group {
    flex: 1 1 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .tree-structure {
    padding-left: 10px !important;
  }

  .account-title {
    font-size: 0.85rem;
    padding: 3px 6px;
  }

  .tree-expand-btn {
    width: 16px;
    height: 16px;
  }

  .tree-leaf-spacer {
    width: 16px;
    height: 16px;
  }
}
</style>
